import type { Tip } from "@/types/content";

export const tips: Tip[] = [
  {
    id: "tip-solar",
    icon: "ri-sun-line",
    title: "Protección todos los días",
    text: "Reaplica tu protector solar cada 3 horas, incluso en interiores con luz natural.",
  },
  {
    id: "tip-noche",
    icon: "ri-moon-clear-line",
    title: "Hidrata antes de dormir",
    text: "Aplica suero y crema sobre piel limpia para aprovechar la regeneración nocturna.",
  },
  {
    id: "tip-rutina",
    icon: "ri-sparkling-2-line",
    title: "Menos productos, más constancia",
    text: "Una rutina simple de 3 pasos usada a diario supera a 10 productos ocasionales.",
  },
];